import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { Control } from 'react-hook-form';

interface FileInputProps {
    field: {
        handle: string;
        label?: string;
        instructions?: string;
        fileKinds?: string[];
        maxFileSizeKB?: number;
    };
    control: Control<Record<string, unknown>>;
}

export default function FileInput({ field, control }: FileInputProps) {
    return (
        <FormField
            control={control}
            name={field.handle}
            render={({ field: formField }) => (
                <FormItem>
                    <FormLabel>{field.label}</FormLabel>
                    <FormControl>
                        <Input
                            type="file"
                            accept={field.fileKinds?.join(',') || '*'}
                            onChange={(e) => formField.onChange(e.target.files?.[0] || null)}
                            className="bg-white"
                        />
                    </FormControl>
                    {field.maxFileSizeKB && (
                        <p className="text-muted-foreground text-sm">
                            Max file size: {Math.round(field.maxFileSizeKB / 1024)}MB
                        </p>
                    )}
                    {field.instructions && (
                        <p className="text-muted-foreground text-sm">{field.instructions}</p>
                    )}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
